import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Icon } from "@evertrue/et-components";
import { colors } from "../style/colors";

const ComingSoon = ({ text = "", url = "https://console.evertrue.com" }) => (
  <Wrapper>
    <Content>
      <Icon icon="build" size={3} />
      <h3>Coming Soon!</h3>
      <div>
        {text ? (
          <p>{text}</p>
        ) : (
          <p>
            We{"'"}re working on a better experience for you. You can currently
            manage this data at
            <a href={url}> console.evertrue.com.</a>
          </p>
        )}
      </div>
    </Content>
  </Wrapper>
);

ComingSoon.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
};

const Content = styled.div`
  padding: 20vh 0;
  max-width: 600px;
  line-height: 21px;
  margin: 0 auto;

  h3 {
    margin-top: 16px;
  }

  i {
    color: ${colors.lightText};
  }
`;

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
`;

export default ComingSoon;
